import {FormatMessageFunction} from '@fo/shared-types';
import {CustomErrorMessages} from '@fo/designSystem/Fields/types';
import {numberPattern} from '@fo/root/formValidation';

interface ValueParams {
  value: number;
  minimumValue?: number;
  maximumValue?: number;
}

const getNumberMessage = (
  formatMessage: FormatMessageFunction,
  valueParams: ValueParams,
  errorMessages?: CustomErrorMessages
): string | undefined => {
  const {minimumValue, maximumValue, value} = valueParams;
  const isMinimumAndMaximumSet = minimumValue && maximumValue;
  const isMinimumValueInvalid = minimumValue && value < minimumValue;
  const isMaximumValueInvalid = maximumValue && value > maximumValue;

  // check for number format
  if (!value.toString().match(numberPattern)) {
    const numberMessage = errorMessages?.number;
    const defaultNumberMessage = formatMessage({id: 'phoenix.errors.number.validFormat'});
    return typeof numberMessage === 'function' ? numberMessage({}) : numberMessage || defaultNumberMessage;
  }

  // check between min and max if both set
  if (isMinimumAndMaximumSet && (isMinimumValueInvalid || isMaximumValueInvalid)) {
    const minMaxMessage = errorMessages?.minMaxNumber;
    const minMaxValues = {minimumValue, maximumValue};
    const defaultMinMaxMessage = formatMessage({id: 'phoenix.errors.number.minAndMax'}, minMaxValues);
    return typeof minMaxMessage === 'function' ? minMaxMessage(minMaxValues) : minMaxMessage || defaultMinMaxMessage;
  }

  // check above min
  if (isMinimumValueInvalid) {
    const minMessage = errorMessages?.minNumber;
    const minValues = {minimumValue};
    const defaultMinMessage = formatMessage({id: 'phoenix.errors.number.min'}, minValues);
    return typeof minMessage === 'function' ? minMessage(minValues) : minMessage || defaultMinMessage;
  }

  // check under max
  if (isMaximumValueInvalid) {
    const maxMessage = errorMessages?.maxNumber;
    const maxValues = {maximumValue};
    const defaultMaxMessage = formatMessage({id: 'phoenix.errors.number.max'}, maxValues);
    return typeof maxMessage === 'function' ? maxMessage(maxValues) : maxMessage || defaultMaxMessage;
  }

  return undefined;
};

export default getNumberMessage;
